import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { ContainerComponent, MobileFloatingFooter, ProgressSteps, SecurityBadges } from "../../ui";
import BookingFormComponent from "../BookingFormComponent";
import PriceComponent from "../PriceComponent";
import RoutesDataComponent from "../RoutesDataComponent";
import { Block, RoutesDataAndFormBlock, Wrapper } from "./style";

const BookingComponent = ({ passengers, handleBookClick, isBookingLoading }) => {
  const { totalPrice } = useSelector(state => state.prebook);
  const { currency } = useSelector(state => state.appConfigs);
  
  const [showFloatingFooter, setShowFloatingFooter] = useState(true);
  const submitButtonRef = useRef(null);

  const handleMobileSubmit = () => {
    const form = document.getElementById('booking-form-submit');
    if (form) form.click();
  };

  // Hide floating footer when main submit button is visible
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // If submit button is visible, hide floating footer
          setShowFloatingFooter(!entry.isIntersecting);
        });
      },
      {
        root: null,
        threshold: 0.1, // Trigger when 10% of button is visible
      }
    );

    // Find the submit button and observe it
    const findAndObserveButton = () => {
      const submitButton = document.getElementById('booking-form-submit');
      if (submitButton) {
        submitButtonRef.current = submitButton;
        observer.observe(submitButton);
      }
    };

    // Try to find button immediately
    findAndObserveButton();

    // If not found, try again after a short delay (for initial render)
    const timeout = setTimeout(findAndObserveButton, 500);

    return () => {
      clearTimeout(timeout);
      if (submitButtonRef.current) {
        observer.unobserve(submitButtonRef.current);
      }
    };
  }, []);

  return (
    <Wrapper>
      <ContainerComponent>
        <ProgressSteps currentStep={2} />

        <Block>
          <RoutesDataAndFormBlock>
            <RoutesDataComponent />
            <BookingFormComponent 
              passengers={passengers} 
              handleBookClick={handleBookClick}
              isBookingLoading={isBookingLoading}
            />
            <SecurityBadges />
          </RoutesDataAndFormBlock>

          <PriceComponent />
        </Block>

        <MobileFloatingFooter
          totalPrice={totalPrice[currency]}
          currency={currency}
          onContinue={handleMobileSubmit}
          isLoading={isBookingLoading}
          isVisible={showFloatingFooter}
        />
      </ContainerComponent>
    </Wrapper>
  );
};

export default BookingComponent;
